import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class BloqueiosKeys extends MainKeys {
    public get place() {
        return Places.bloqueios
    }
}

export default BloqueiosKeys
